import React, { useState, useRef } from 'react';
import { isArray, isBoolean } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBars } from '@fortawesome/free-solid-svg-icons';

import { MenuButton, Menu, Header, Content } from '../../styles/slide-out-menu';
import Tile from './menu-tile';

export default function SlideOutMenu({ hotspots, defaultOpen=false }) {

	const [ isOpen, setOpen ] = useState(isBoolean(defaultOpen)? defaultOpen : false);
	const menuRef = useRef(null);
	
	const hotspotPropList = (isArray(hotspots)? hotspots : [hotspots])
														.map((hotspot) => hotspot.props);

	return(
		<>
			<MenuButton onClick={() => setOpen(true)} >
				<p>All Content</p>
				<FontAwesomeIcon icon={faBars} />
			</MenuButton>
			<Menu open={isOpen} ref={menuRef} >
				<Header onClick={() => setOpen(false)} >
					<p>All Content</p>
					<FontAwesomeIcon icon={faTimes} />
				</Header>
				<Content>
					{
						hotspotPropList.map((hotspotProps, index) => <Tile
							key={'tile_'+index}
							{ ...hotspotProps }
						/>)
					}
				</Content>
			</Menu>
		</>
	);
}